import { render, staticRenderFns } from "./FormTutoratedit.vue?vue&type=template&id=ab88c678&"
import script from "./FormTutoratedit.vue?vue&type=script&lang=js&"
export * from "./FormTutoratedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports